(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class ShopTheLook extends HTMLElement {
    connectedCallback() {
      this.active = null;
      this.closeTimer = null;
      this.spots = Array.from(this.querySelectorAll('[data-hotspot]'));

      this.spots.forEach((spot) => {
        const dot = spot.querySelector('.shop-the-look__dot');
        const card = spot.querySelector('.shop-the-look__card-wrap');
        if (!dot) return;

        dot.addEventListener('mouseenter', () => this.open(spot));
        dot.addEventListener('mouseleave', () => this.scheduleClose());
        dot.addEventListener('focus', () => {
          if (dot.matches(':focus-visible')) this.open(spot);
        });
        dot.addEventListener('blur', () => this.scheduleClose());
        dot.addEventListener('click', () => this.toggle(spot));
        dot.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeNow();
            dot.blur();
          }
        });

        if (card) {
          card.addEventListener('mouseenter', () => this.open(spot));
          card.addEventListener('mouseleave', () => this.scheduleClose());
        }
      });
    }

    disconnectedCallback() {
      clearTimeout(this.closeTimer);
    }

    open(spot) {
      clearTimeout(this.closeTimer);
      this.setActive(spot);
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.setActive(null), 160);
    }

    closeNow() {
      clearTimeout(this.closeTimer);
      this.setActive(null);
    }

    toggle(spot) {
      clearTimeout(this.closeTimer);
      this.setActive(this.active === spot ? null : spot);
    }

    setActive(spot) {
      this.active = spot;
      this.spots.forEach((item) => {
        const on = item === spot;
        item.classList.toggle('is-active', on);
        const dot = item.querySelector('.shop-the-look__dot');
        if (dot) dot.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('shop-the-look')) {
    customElements.define('shop-the-look', ShopTheLook);
  }

  } catch(e) { console.error(e); }
})();
})();
